import React from 'react';
import {Link} from 'react-router-dom'
import {Modal, Button} from 'react-bootstrap'


export class AddStockItemButton extends React.Component {
  render() {
    return <Link to="/stock_items/create" className="btn btn-info ">Create New Stock Item</Link>

  }
}


export class DeleteStockItemButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.state = {show: false}
  }
  handleDelete() {
    this.setState({show:false})
    this.props.handleDelete()
  }
  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    const selectedRows = this.props.selectedRows

    let show = this.state.show
    let btn
    if(typeof this.props.stock.deleting_stock !== "undefined" && this.props.stock.deleting_stock) {
      show = false
      btn =   <button className="btn btn-danger" disabled>Deleting... </button>
    }
    else {
      btn = (<button className="btn btn-danger" onClick={this.handleShow}>Delete {selectedRows.length}</button>)
    }




    const modal = (
        <Modal show={show} onHide={this.handleClose}>
          <Modal.Header closeButton>
           <Modal.Title>Confirm Delete</Modal.Title>
         </Modal.Header>
          <Modal.Body>
            Total {selectedRows.length} {selectedRows.length === 1 ? "row": "rows" } selected
          </Modal.Body>
          <Modal.Footer>
           <Button onClick={this.handleClose}>Close</Button>
           <Button onClick={this.handleDelete} bsStyle="danger">Delete</Button>
         </Modal.Footer>
        </Modal>
    )

    if(selectedRows.length > 0) {
      return (
        <span>
          {modal}
          {btn}

      </span>

)
    }
    return null

  }
}



// WEBPACK FOOTER //
// ./src/components/stockitem/utils.js